import { Outlet } from 'react-router-dom';
import { PushPromptModal } from '@/components/common';
import { useUnreadCount } from '@/features/notifications';
import { useWebSocketEvents } from '@/hooks';
import { cn } from '@/lib';
import { useUiStore } from '@/stores';
import { AdminHeader } from './AdminHeader';
import { AdminSidebar } from './AdminSidebar';

export function AdminLayout() {
  const { sidebarOpen, setSidebarOpen } = useUiStore();
  useWebSocketEvents();
  useUnreadCount();

  return (
    <div className="min-h-screen bg-admin-bg">
      {/* Skip to main content link */}
      <a
        href="#main-content"
        className="sr-only focus:not-sr-only focus:fixed focus:top-2 focus:left-2 focus:z-[100] focus:rounded-lg focus:bg-primary focus:px-4 focus:py-2 focus:text-sm focus:font-medium focus:text-white focus:shadow-lg"
      >
        Preskoči na sadržaj
      </a>

      {/* Mobile backdrop */}
      {sidebarOpen && (
        <button
          type="button"
          aria-label="Zatvori meni"
          className="fixed inset-0 z-40 bg-black/30 lg:hidden"
          onClick={() => setSidebarOpen(false)}
        />
      )}

      <PushPromptModal />
      <AdminSidebar />
      <AdminHeader />
      <main
        id="main-content"
        className={cn(
          'pt-16 transition-all duration-200',
          'lg:ml-16',
          sidebarOpen ? 'lg:ml-60' : 'lg:ml-16'
        )}
      >
        <div className="p-4 sm:p-6">
          <Outlet />
        </div>
      </main>
    </div>
  );
}
